/** @flow */

import {
  GetNotifications,
  GetNotificationsSuccess,
  GetNotificationsError,
  GetNotificationsTargets,
  GetNotificationsTargetsSuccess,
  GetNotificationsTargetsError,
  ToggleAddNotificationModal,
  ToggleEditNotificationModal,
  GetAddNotificationModalEmployeeList,
  GetAddNotificationModalEmployeeListSuccess,
  GetAddNotificationModalEmployeeListError,
  ResetAddNotificationModalEmployeeList,
  GetNotificationSchema,
  GetNotificationSchemaSuccess,
  GetNotificationSchemaError,
  GetHierarchyNotifications,
  GetHierarchyNotificationsSuccess,
  GetHierarchyNotificationsError,
  GetHierarchyNotificationsTargets,
  GetHierarchyNotificationsTargetsSuccess,
  GetHierarchyNotificationsTargetsError,
  GetMyEmployeeNotificationsSuccess,
  GetIndividualsRevisionHistory,
  GetIndividualsRevisionHistorySuccess,
  GetIndividualsRevisionHistoryError,
  ToggleIndividualsRevisionHistoryModal,
  CreateNotificationTarget,
  CreateNotificationTargetSuccess,
  CreateNotificationTargetError,
  SearchNotificationAuditByStatus,
  SearchNotificationAuditByStatusSuccess,
  SearchNotificationAuditByStatusError,
  UpdateNotificationAuditStatus,
  UpdateNotificationAuditStatusSuccess,
  UpdateNotificationAuditStatusError,
  NotificationAuditRemoveAccessToRecord,
  NotificationAuditRemoveAccessToRecordSuccess,
  NotificationAuditRemoveAccessToRecordError,
  CreateNotification,
  CreateNotificationSuccess,
  CreateNotificationError,
  ResetNotificationModalEmployeeList,
  GetSharedEmployeeLookupPositionsSuccess,
} from "@modules/shared/constants/actions";
import * as reducers from "./reducers";
import type { NotificationsState } from "./types";
import initialState from "./state";
import { cloneObject } from "@utils/object";

export default (state: NotificationsState = initialState, action: Object): NotificationsState => {
  const act = {
    [GetNotifications]: reducers.setLoading,
    [GetNotificationsSuccess]: reducers.onGetNotificationsSuccess,
    [GetNotificationsError]: reducers.onGetNotificationsError,
    [GetMyEmployeeNotificationsSuccess]: reducers.onGetMyEmployeeNotificationsSuccess,
    [GetNotificationsTargets]: reducers.setLoading,
    [GetNotificationsTargetsSuccess]: reducers.onGetNotificationsTargetsSuccess,
    [GetNotificationsTargetsError]: reducers.onGetNotificationsTargetsError,
    [CreateNotificationTarget]: reducers.setLoading,
    [CreateNotificationTargetSuccess]: reducers.setLoaded,
    [CreateNotificationTargetError]: reducers.setLoaded,

    [CreateNotification]: reducers.setLoading,
    [CreateNotificationSuccess]: reducers.setLoaded,
    [CreateNotificationError]: reducers.setLoaded,
    [ToggleAddNotificationModal]: reducers.onToggleAddNotificationModal,
    [ToggleEditNotificationModal]: reducers.onToggleEditNotificationModal,
    [GetAddNotificationModalEmployeeList]: reducers.setLoading,
    [GetAddNotificationModalEmployeeListSuccess]:
      reducers.onGetAddNotificationModalEmployeeListSuccess,
    [ResetAddNotificationModalEmployeeList]: reducers.onResetAddNotificationModalEmployeeList,
    [GetAddNotificationModalEmployeeListError]: reducers.onGetAddNotificationModalEmployeeListError,
    [ResetNotificationModalEmployeeList]: reducers.onResetNotificationModalEmployeeList,
    [GetNotificationSchema]: reducers.setLoading,
    [GetNotificationSchemaSuccess]: reducers.onGetNotificationSchemaSuccess,
    [GetNotificationSchemaError]: reducers.onGetNotificationSchemaError,
    [GetHierarchyNotifications]: reducers.setLoading,
    [GetHierarchyNotificationsSuccess]: reducers.onGetHierarchyNotificationsSuccess,
    [GetHierarchyNotificationsError]: reducers.onGetHierarchyNotificationsError,
    [GetHierarchyNotificationsTargets]: reducers.setLoading,
    [GetHierarchyNotificationsTargetsSuccess]: reducers.onGetHierarchyNotificationsTargetsSuccess,
    [GetHierarchyNotificationsTargetsError]: reducers.onGetHierarchyNotificationsTargetsError,
    [GetIndividualsRevisionHistory]: reducers.setLoading,
    [GetIndividualsRevisionHistorySuccess]: reducers.onGetIndividualsRevisionHistorySuccess,
    [GetIndividualsRevisionHistoryError]: reducers.onGetIndividualsRevisionHistoryError,
    [ToggleIndividualsRevisionHistoryModal]: reducers.onToggleIndividualsRevisionHistoryModal,
    [SearchNotificationAuditByStatus]: reducers.setLoading,
    [SearchNotificationAuditByStatusSuccess]: reducers.onSearchNotificationAuditByStatusSuccess,
    [SearchNotificationAuditByStatusError]: reducers.setLoaded,
    [UpdateNotificationAuditStatus]: reducers.setLoading,
    [UpdateNotificationAuditStatusSuccess]: reducers.setLoaded,
    [UpdateNotificationAuditStatusError]: reducers.setLoaded,
    [NotificationAuditRemoveAccessToRecord]: reducers.setLoading,
    [NotificationAuditRemoveAccessToRecordSuccess]: reducers.setLoaded,
    [NotificationAuditRemoveAccessToRecordError]: reducers.setLoaded,
    [GetSharedEmployeeLookupPositionsSuccess]: reducers.onGetSharedEmployeeLookupPositionsSuccess,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
